export const invertedMessages = {
  'Don’t show this again for this certification': 'CONSULT_DONT_SHOW_LABEL',
};
